"use client"

import { IconListDetails } from "@tabler/icons-react"
import { NavbarOptionButton } from "@/components/generic/SideNavBar/components/NavbarOptionButton/NavbarOptionButton"

interface NavbarPowerDialerButtonProps {
  isSelected: boolean
  label: string
}

export function NavbarPowerDialerButton({ isSelected, label }: NavbarPowerDialerButtonProps) {
  return <NavbarOptionButton icon={IconListDetails} isSelected={isSelected} label={label} href="/power-dialer" />
}
